/** Hook to handle persistence of the scores, either in Tunasong storage, or local storage */

import { useCurrentUser } from '@tunasong/redux'
import { type Game } from '@tunasong/schemas'
import { useScorePersistEntity } from './score-persist-entity.js'
import { useScorePersistIndexedDB } from './score-persist-indexeddb.js'
import { generateName } from './random-name.js'

const name = generateName()
export const useScorePersist = ({ game, userName }: { game: Game; userName: string }) => {
  const { userId } = useCurrentUser()

  const entityHook = useScorePersistEntity({ game, userName, userId })
  const indexedDBHook = useScorePersistIndexedDB({ game, nickName: name })

  return userId ? entityHook : indexedDBHook
}
